import localforage from 'localforage'

localforage.config({
	driver: localforage.INDEXEDDB,
	name: 'cashassist',
	version: 1.0,
	storeName: 'cashassist'
})

/* fixes this: https://github.com/aws-amplify/amplify-js/issues/3284 */
window.sessionStorage.workaround = null
window.localStorage.workaround = null


export const amplifyStorage = JSON.parse(sessionStorage.getItem('useSessionStorage')) ? window.sessionStorage : window.localStorage
export const apolloStorage = localforage
